import {
  BINDINGS,
  isChangeableField,
  isRequiredByRecord,
  type BoundField,
  type InstanceKind,
} from "shared"
import { Checkbox } from "@rawa/ui/Checkbox"
import { InputField } from "@rawa/ui/InputField"
import type { BoundFieldEdit } from "../stores/moduleState"
import { FORM_MODE, RECORD_OWNER, requiredByRecord } from "../utils/boundFields"
import styles from "./BoundFieldProperties.module.css"

/**
 * What a bound field on the canvas shows, how it behaves on the form, and the
 * name it goes by. Blank is no name: the field is called what it is bound to.
 * A changeable field shows Required as a custom field's does: locked on where
 * its record makes it Required, since the record sets it (ADR-039 decision
 * 13), and otherwise the administrator's to set. Each change is reported as the
 * edit to apply, as a custom field's are.
 */
export function BoundFieldProperties({
  field,
  about,
  onEdit,
}: {
  field: BoundField
  about: InstanceKind
  onEdit: (edit: BoundFieldEdit) => void
}) {
  const binding = BINDINGS[field.binding]
  return (
    <div className={styles.properties}>
      <InputField
        id="field-name"
        label="Name"
        value={field.label ?? ""}
        placeholder={binding.label}
        onChange={(label) =>
          onEdit({ label: label.trim() ? label : undefined })
        }
      />
      <p className={styles.explained}>
        Shows {RECORD_OWNER[about]} {binding.label}.{" "}
        {FORM_MODE[binding.formMode].explained}
      </p>
      {isRequiredByRecord(field) ? (
        <Checkbox
          checked
          label="Required"
          size="small"
          disabled
          hint={requiredByRecord(about)}
        />
      ) : (
        isChangeableField(field) && (
          <Checkbox
            checked={field.required ?? false}
            label="Required"
            size="small"
            onChange={(required) => onEdit({ required })}
          />
        )
      )}
    </div>
  )
}
